/**
 * 公共视口断点常量（与 CSS 媒体查询一致）
 * 用于 PC 与移动端兼容控制
 */
export const BREAKPOINTS = {
  /** 移动端：< 768px */
  MOBILE: 768,
  /** 平板：768px - 1024px */
  TABLET: 1024,
  /** 小屏移动：< 480px */
  MOBILE_SM: 480,
  /** 超小屏：< 360px */
  MOBILE_XS: 360,
};

/** 当前断点名称 */
export const BREAKPOINT_NAMES = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
};

/**
 * 根据宽度获取断点名称
 * @param {number} width - 视口宽度
 * @returns {string} 'mobile' | 'tablet' | 'desktop'
 */
export function getBreakpointName(width) {
  if (width < BREAKPOINTS.MOBILE) return BREAKPOINT_NAMES.MOBILE;
  if (width < BREAKPOINTS.TABLET) return BREAKPOINT_NAMES.TABLET;
  return BREAKPOINT_NAMES.DESKTOP;
}
